import { rpc } from './ws';

export interface FaqEntry {
  id: string;
  q: { en: string; ru: string };
  a: { en: string; ru: string };
}

export interface AppConfig {
  support: { telegram: string; email: string };
  faq: FaqEntry[];
}

/** App config (support contacts + bilingual FAQ) — over the authed WS connection. */
export const fetchConfig = () => rpc<AppConfig>('config.get');
